const PageLoader = () => (
  <div className="page-loader">
    <svg className="z-loader" viewBox="0 0 100 100">
      <path className="z-loader-path" d="M 20 20 L 80 20 L 20 80 L 80 80" />
    </svg>
  </div>
);
export default PageLoader;